import { getApi } from "../apiCall";

export const getAllEnergyType = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllEnergyType/public`;
  return getApi(url);
};

export const getAllDiscom = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllDiscom/public`;
  return getApi(url);
};

export const getAllPoints = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllPointValue/public`;
  return getApi(url);
};

export const getAllVoltage = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllVoltageLevel/public`;
  return getApi(url);
};

export const getAllRegion = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllRegion/public`;
  return getApi(url);
};

export const getAllStateUT = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllStateAndUt/public`;
  return getApi(url);
};

export const getAllCity = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllCity/public`;
  return getApi(url);
};

export const getAllCreditRating = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllCreditRating/public`;
  return getApi(url);
};

export const getAllNationality = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllNationality/public`;
  return getApi(url);
};

export const getAllGridConnection = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllPointValue/public`;
  return getApi(url);
};

export const getAllHoldingCompany = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllHoldingCompany/public`;
  return getApi(url);
};

export const getAllCategory = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllCategory/public`;
  return getApi(url);
};

export const getSpecefication = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllSpecification/public`;
  return getApi(url);
};

export const getControlArea = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllControlArea/public`;
  return getApi(url);
};

export const getStateByRegionId = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getStateUtByRegionId/public?regionId=${id}`;
  return getApi(url);
};

export const getDiscomByStateId = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getDiscomByStateUtId/public?stateUtId=${id}`;
  return getApi(url);
};

export const getAllCityByStateId = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/initialData/getAllCity/public?stateUtId=${id}`;
  return getApi(url);
};